import { useEffect, useRef, useState } from 'react';

const WA_LINK = 'https://wa.me/5547984929295?text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20a%20advogada.';

export default function Hero() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      id="inicio"
      ref={ref}
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=sophisticated%20and%20elegant%20modern%20law%20office%20interior%20with%20warm%20ambient%20lighting%2C%20dark%20wooden%20shelves%20filled%20with%20law%20books%2C%20minimalist%20design%2C%20soft%20cream%20and%20beige%20tones%20with%20deep%20teal%20accents%2C%20large%20window%20with%20gentle%20natural%20light%20streaming%20in%2C%20premium%20professional%20atmosphere%2C%20warm%20golden%20hour%20glow%2C%20refined%20and%20inviting%20space%2C%20architectural%20interior%20photography%2C%20no%20people%2C%20ultra%20high%20quality%2C%20editorial%20style&width=1920&height=1080&seq=hero-leide-001&orientation=landscape"
          alt="Escritório Leide Gonçalves Advocacia"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-ink-black/90 via-ink-black/75 to-ink-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 md:px-6 py-32">
        <div className="max-w-2xl">
          {/* Badge */}
          <div
            className={`inline-flex items-center gap-2 mb-8 transition-all duration-700 delay-100 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          >
            <div className="h-px w-10 bg-burnt-peach"></div>
            <span className="text-burnt-peach text-xs tracking-[0.2em] uppercase font-sans font-medium">
              Direito de Família &amp; Sucessões
            </span>
          </div>

          {/* H1 */}
          <h1
            className={`font-serif text-white text-4xl md:text-5xl lg:text-6xl font-semibold leading-tight mb-6 transition-all duration-700 delay-200 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          >
            Acolhimento e segurança jurídica nos momentos{' '}
            <em className="text-burnt-peach not-italic">que mais importam.</em>
          </h1>

          {/* Subtitle */}
          <p
            className={`text-white/75 text-lg leading-relaxed mb-10 font-sans font-light transition-all duration-700 delay-300 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          >
            Especializada em Direito de Família e Sucessões. Atendimento humano e estratégico.
          </p>

          {/* CTAs */}
          <div
            className={`flex flex-wrap gap-4 transition-all duration-700 delay-400 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          >
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center gap-3 bg-burnt-peach hover:bg-burnt-peach-light text-white font-sans font-medium px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap text-sm"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              Falar com a advogada
            </a>
            <a
              href="#areas"
              onClick={(e) => { e.preventDefault(); document.querySelector('#areas')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="flex items-center gap-2 border border-white/40 hover:border-white text-white font-sans font-medium px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap text-sm cursor-pointer"
            >
              Ver áreas de atuação
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40">
        <span className="text-xs tracking-widest uppercase font-sans">Role para baixo</span>
        <div className="w-px h-12 bg-gradient-to-b from-white/40 to-transparent animate-pulse"></div>
      </div>
    </section>
  );
}
